module.exports = __webpack_public_path__ + "static/media/Brillando_en_tres_mercados.ef05b176.jpg";